import reqest from "../common/reqest";


/**
 * 获取用户信息
 * @param data
 * @returns {Promise<unknown>}
 */
export function getUserInfo(data) {
  return reqest.send("/Login/User_Details",data)
}

